(function () {
  var enterModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.enterModule : undefined;
  enterModule && enterModule(module);
})();

var __signature__ = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default.signature : function (a) {
  return a;
};

import { useNavigate } from "react-router";
import { useLocation } from "react-router-dom";
import { useEffect, useMemo } from "react";
import { getDigits } from "../../../../utils/string";

const useValidateUrl = _ref => {
  let {
    hsCode
  } = _ref;
  const navigate = useNavigate();
  const location = useLocation();
  const normalizedCode = useMemo(() => getDigits(hsCode).slice(0, 6), [hsCode]);
  useEffect(() => {
    if (hsCode !== normalizedCode) {
      const pathname = location.pathname.replace(/\/search\/.*$/, "/search/".concat(normalizedCode));
      navigate({
        pathname,
        search: location.search,
        replace: true
      }, {
        state: {
          action: "REPLACE"
        }
      });
    }
  }, [normalizedCode, location, navigate, hsCode]);
};

__signature__(useValidateUrl, "useNavigate{navigate}\nuseLocation{location}\nuseMemo{normalizedCode}\nuseEffect{}", () => [useNavigate, useLocation]);

const _default = useValidateUrl;
export default _default;
;

(function () {
  var reactHotLoader = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default : undefined;

  if (!reactHotLoader) {
    return;
  }

  reactHotLoader.register(useValidateUrl, "useValidateUrl", "/root/local/TeamCity/buildAgent/work/bac1af6cbd11267e/src/modules/Search/containers/hooks/useValidateUrl.js");
  reactHotLoader.register(_default, "default", "/root/local/TeamCity/buildAgent/work/bac1af6cbd11267e/src/modules/Search/containers/hooks/useValidateUrl.js");
})();

;

(function () {
  var leaveModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.leaveModule : undefined;
  leaveModule && leaveModule(module);
})();